import React, { ReactChild, ReactNode, useState } from 'react'

import { CarouselProps } from '@hhgtech/hhg-components/mantine'
import { Embla } from '@mantine/carousel'

import { CarouselOrListingBlockContext } from './context'
import { LazyLoadItem } from './lazyLoadItem'
import { Paging } from './paging'
import { Slider } from './slider'

export type SlideInfoProps = {
  canScrollNext: boolean
  canScrollPrev: boolean
  slidesInView: number[]
  currentSlide: number
  totalSlide: number
}

export type CarouselOrListingBlockProps = {
  children: ReactNode
  lengthToCarouselDesktop?: number
  lengthToCarouselMobile?: number
  percentOfEndSlideDesktop?: number
  percentOfEndSlideMobile?: number
  hasShadowAtEndSlide?: boolean
  showFullSlide?: boolean
  carouselSetting?: Partial<CarouselProps>
  gapDesktop?: number
  gapMobile?: number
  disableCarousel?: boolean
  lazyLoad?: boolean
  autoPlay?: boolean
  delayTime?: number
  onSlideChange?: (v: number) => void
  hideProgressBar?: boolean
}

const _CarouselOrListingBlock = ({
  children = [],
  ...props
}: CarouselOrListingBlockProps) => {
  const [embla, setEmbla] = useState<Embla | null>(null)
  const [filteredChild, setFilteredChild] = useState<ReactChild[]>([])

  return (
    <CarouselOrListingBlockContext.Provider
      value={{
        embla,
        setEmbla,
        filteredChild,
        setFilteredChild,
        ...props,
      }}
    >
      {children}
    </CarouselOrListingBlockContext.Provider>
  )
}

export interface CompoundedComponent
  extends React.ForwardRefExoticComponent<CarouselOrListingBlockProps> {
  LazyLoadItem: typeof LazyLoadItem
  Paging: typeof Paging
  Slider: typeof Slider
}

const CarouselOrListingBlock = _CarouselOrListingBlock as CompoundedComponent
CarouselOrListingBlock.LazyLoadItem = LazyLoadItem
CarouselOrListingBlock.Paging = Paging
CarouselOrListingBlock.Slider = Slider

export { CarouselOrListingBlock }
